"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketResponse = exports.WebsocketMetadata = exports.WebsocketFileParams = void 0;
const StoryNodeDisplayType_1 = require("../../storyV2/domain/StoryNodeDisplayType");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
class WebsocketFileParams {
    constructor(file_url, method, body, headers) {
        this.file_url = file_url;
        this.method = method;
        this.body = body;
        this.headers = headers;
    }
}
exports.WebsocketFileParams = WebsocketFileParams;
class WebsocketMetadata {
    constructor(response, error) {
        this.response = response;
        this.error = error;
    }
}
exports.WebsocketMetadata = WebsocketMetadata;
class WebsocketResponse {
    constructor(status, metadata, type, 
    /**
     * for blueprint execute currently
     */
    data, response, text, html, audio, audio_url, image, image_url, video, video_url, pdf, pdf_url, ask_brain, /// json | undefined
    method, body, headers, error, event, message, state) {
        this.status = status;
        this.metadata = metadata;
        this.type = type;
        this.data = data;
        this.response = response;
        this.text = text;
        this.html = html;
        this.audio = audio;
        this.audio_url = audio_url;
        this.image = image;
        this.image_url = image_url;
        this.video = video;
        this.video_url = video_url;
        this.pdf = pdf;
        this.pdf_url = pdf_url;
        this.ask_brain = ask_brain;
        this.method = method;
        this.body = body;
        this.headers = headers;
        this.error = error;
        this.event = event;
        this.message = message;
        this.state = state;
    }
    get succeed() {
        if (this.status && this.status === "failed") {
            return false;
        }
        /// 如果不存在 stauts
        return true;
    }
    get displayType() {
        /// 如果 type 为空，展示 text, 值为 metadata.response
        if ((0, is_blank_1.default)(this.type)) {
            return StoryNodeDisplayType_1.StoryNodeDisplayType.TEXT;
        }
        const displayType = WebsocketResponse.wsTypesMap.get(this.type);
        if (displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.UPLOADIMAGE && (!(0, is_blank_1.default)(this.image_url) || !(0, is_blank_1.default)(this.image))) {
            return StoryNodeDisplayType_1.StoryNodeDisplayType.UPLOADIMAGE;
        }
        if (displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.AUDIO && (!(0, is_blank_1.default)(this.audio_url) || !(0, is_blank_1.default)(this.audio))) {
            return StoryNodeDisplayType_1.StoryNodeDisplayType.AUDIO;
        }
        if (displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.BASEVIDEO && (!(0, is_blank_1.default)(this.video_url) || !(0, is_blank_1.default)(this.video))) {
            return StoryNodeDisplayType_1.StoryNodeDisplayType.BASEVIDEO;
        }
        if (displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.PDFFILE && (!(0, is_blank_1.default)(this.pdf_url) || !(0, is_blank_1.default)(this.pdf))) {
            return StoryNodeDisplayType_1.StoryNodeDisplayType.PDFFILE;
        }
        if (displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.HTML && !(0, is_blank_1.default)(this.html)) {
            return StoryNodeDisplayType_1.StoryNodeDisplayType.HTML;
        }
        if (displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.ASKBRAIN && !(0, is_blank_1.default)(this.ask_brain)) {
            return StoryNodeDisplayType_1.StoryNodeDisplayType.ASKBRAIN;
        }
        return StoryNodeDisplayType_1.StoryNodeDisplayType.TEXT;
    }
    get content() {
        /// 如果 type 为空，展示 text, 值为 metadata.response
        if ((0, is_blank_1.default)(this.type)) {
            return this.metadata?.response;
        }
        /// 类型为 html
        /// 如果存在 html 数据（返回 undefined）
        if (this.displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.HTML && !(0, is_blank_1.default)(this.html)) {
            return undefined;
        }
        /// 类型为 ask_brain
        /// 如果存在 ask_brain 数据（返回 undefined）
        if (this.displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.ASKBRAIN && !(0, is_blank_1.default)(this.ask_brain)) {
            return undefined;
        }
        /// 类型为图片/音频/视频/PDF文件，
        /// 如果存在链接/使用链接（返回 undefined）
        if (this.isFileUrlTypes && !(0, is_blank_1.default)(this.fileParams?.file_url)) {
            return undefined;
        }
        /// 兼容处理，如果 type === image_url 但是 image_url 值为空
        return this.text || this.metadata?.response;
    }
    /// 通过 url 加载数据的类型
    get isFileUrlTypes() {
        return (this.displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.UPLOADIMAGE ||
            this.displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.AUDIO ||
            this.displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.BASEVIDEO ||
            this.displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.PDFFILE);
    }
    get fileParams() {
        if (this.displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.UPLOADIMAGE) {
            return new WebsocketFileParams(this.image_url || this.image, this.method, this.body, this.headers);
        }
        if (this.displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.BASEVIDEO) {
            return new WebsocketFileParams(this.video_url || this.video, this.method, this.body, this.headers);
        }
        if (this.displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.AUDIO) {
            return new WebsocketFileParams(this.audio_url || this.audio, this.method, this.body, this.headers);
        }
        if (this.displayType === StoryNodeDisplayType_1.StoryNodeDisplayType.PDFFILE) {
            return new WebsocketFileParams(this.pdf_url || this.pdf, this.method, this.body, this.headers);
        }
        return undefined;
    }
    get errorMsg() {
        return this.metadata?.error;
    }
    get isPlaceholderMessage() {
        if (!this.event || (0, is_blank_1.default)(this.event)) {
            return false;
        }
        return this.event.startsWith("on_llm") || this.event.startsWith("on_tool_start");
    }
    get isCompleted() {
        if (this.state?.toLowerCase() === "success" || this.status?.toLowerCase() === "succeed") {
            return true;
        }
        // FIXME: 临时先这样处理
        if ((0, is_blank_1.default)(this.data) === false) {
            return true;
        }
        return false;
    }
}
exports.WebsocketResponse = WebsocketResponse;
WebsocketResponse.wsTypesMap = new Map([
    ["image", StoryNodeDisplayType_1.StoryNodeDisplayType.UPLOADIMAGE],
    ["image_url", StoryNodeDisplayType_1.StoryNodeDisplayType.UPLOADIMAGE],
    ["audio", StoryNodeDisplayType_1.StoryNodeDisplayType.AUDIO],
    ["audio_url", StoryNodeDisplayType_1.StoryNodeDisplayType.AUDIO],
    ["video", StoryNodeDisplayType_1.StoryNodeDisplayType.BASEVIDEO],
    ["video_url", StoryNodeDisplayType_1.StoryNodeDisplayType.BASEVIDEO],
    ["html", StoryNodeDisplayType_1.StoryNodeDisplayType.HTML],
    ["pdf", StoryNodeDisplayType_1.StoryNodeDisplayType.PDFFILE],
    ["pdf_url", StoryNodeDisplayType_1.StoryNodeDisplayType.PDFFILE],
    ["ask_brain", StoryNodeDisplayType_1.StoryNodeDisplayType.ASKBRAIN],
    ["text", StoryNodeDisplayType_1.StoryNodeDisplayType.TEXT],
]);
